import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '100%'
  },

  mobileRole: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '100%',
    '@media (max-width: 959px)': {
      //mobile botom nav bar height
      height: ' calc(100% - 40px)'
    }
  },

  titleRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    fontSize: theme.size.base,
    color: '#3C425B'
  },

  children: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: '80svh',
    overflow: 'hidden auto',
    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: theme.palette.nearWhite
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B64FCD',
      borderRadius: 0
    }
  }
}))

export default useStyles
